<template>
  <div class="flex flex-col h-full px-4 sm:px-6 overflow-y-auto">
    <div class="py-4 flex-1">
      <slot />
    </div>
  </div>
</template>
